import type { INavItem } from "@/models/INavItem";
import { HeadphonesIcon } from "lucide-react";

// Dashboard
import { DashboardRoutes, dashboardNav } from "./dashboard";

// Reservations
import { ReservationRoutes, reservationNav } from "./reservations";

// Flights
import { FlightRoutes, flightNav } from "./flights";

// Hotels
import { HotelRoutes, hotelNav } from "./hotels";

// Packages
import { PackageRoutes, packageNav } from "./packages";

// Transfers
import { TransferRoutes, transferNav } from "./transfers";

// Customers
import { CustomerRoutes, customerNav } from "./customers";

// Support
import { SupportRoutes } from "./support";

// Reporting
import { ReportRoutes, reportNav } from "./reporting";

// Settings
import { SettingsRoutes, settingsNav } from "./settings";

// Landing Pages
import { LandingPageRoutes, landingPageNav } from "./landing-pages";

// Marketing image library (shared with ticketon-marketing-admin)
import { AssetRoutes, assetsNav } from "./assets";

// Travel Analytics
import { TravelAnalyticsRoutes, travelAnalyticsNav } from "./travel-analytics";

// Advanced Analytics (self-service / Mixpanel-like)
import { AdvancedAnalyticsRoutes, advancedAnalyticsNav } from "./advanced-analytics";

// Deals
import { DealsRoutes, dealsNav } from "./deals";

// Rewards
import { RewardsRoutes, rewardsNav } from "./rewards";
// Providers
import { ProviderRoutes } from "./providers";

// Issue Supports
import { IssueSupportTemplateRoutes } from "./issue-support-templates";

// Email templates (and the airline catalog they read check-in URLs from)
import { EmailTemplateRoutes, emailTemplateNav } from "./email-templates";

// Email automations (trigger + conditions → email template)
import { EmailAutomationRoutes, emailAutomationNav } from "./email-automations";

// Upsells (tours and hotels offered in emails and on the confirmation page)
import { TravelUpsellRoutes, travelUpsellNav } from "./upsells";

// Customer Support group - contains reservations, flights, hotels, packages, transfers, customers
// This group is visible if user has any permission from the contained modules
const customerSupportNav: INavItem = {
  labelKey: "nav.customer_support",
  icon: HeadphonesIcon,
  path: reservationNav.path, // Default to reservations
  // No permissionPrefix since this is a composite group - visibility is determined by children
  children: [
    { labelKey: reservationNav.labelKey, path: reservationNav.path, permissions: reservationNav.permissions },
    { labelKey: flightNav.labelKey, path: flightNav.path, permissions: flightNav.permissions },
    { labelKey: hotelNav.labelKey, path: hotelNav.path, permissions: hotelNav.permissions },
    { labelKey: packageNav.labelKey, path: packageNav.path, permissions: packageNav.permissions },
    { labelKey: transferNav.labelKey, path: transferNav.path, permissions: transferNav.permissions },
    { labelKey: customerNav.labelKey, path: customerNav.path, permissions: customerNav.permissions },
  ],
};

// Aggregate all navigation items
export const moduleNavItems: INavItem[] = [
  dashboardNav,
  customerSupportNav,
  travelAnalyticsNav,
  advancedAnalyticsNav,
  dealsNav,
  rewardsNav,
  reportNav,
  landingPageNav,
  assetsNav,
  emailTemplateNav,
  emailAutomationNav,
  travelUpsellNav,
  settingsNav,
];

// Re-export all routes for convenience
export {
  DashboardRoutes,
  ReservationRoutes,
  FlightRoutes,
  HotelRoutes,
  PackageRoutes,
  TransferRoutes,
  CustomerRoutes,
  SupportRoutes,
  ReportRoutes,
  SettingsRoutes,
  LandingPageRoutes,
  AssetRoutes,
  TravelAnalyticsRoutes,
  AdvancedAnalyticsRoutes,
  DealsRoutes,
  RewardsRoutes,
  ProviderRoutes,
  IssueSupportTemplateRoutes,
  EmailTemplateRoutes,
  EmailAutomationRoutes,
  TravelUpsellRoutes,
};

// Re-export individual module exports
export * from "./dashboard";
export * from "./reservations";
export * from "./flights";
export * from "./hotels";
export * from "./packages";
export * from "./transfers";
export * from "./customers";
export * from "./support";
export * from "./reporting";
export * from "./settings";
export * from "./landing-pages";
export * from "./assets";
export * from "./travel-analytics";
export * from "./advanced-analytics";
export * from "./deals";
export * from "./rewards";
export * from "./providers";
export * from "./issue-support-templates";
export * from "./email-templates";
export * from "./email-automations";
export * from "./upsells";
